<template>
  <section class="quiz-list-section">
    <b-container class="h-100">
      <div class="quiz-list-wrapper">
        <div class="content">
          <ul>
            <li v-for="(data, index) in list" :key="'quiz' + index">
              <router-link :to="`/quiz/${data.lessonSlug}`">
                {{data.name}}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
import {QuizService} from "../data/services/quiz.service";
export default {
  name: "QuizList",
  data() {
    return {
      isLoading: true,
      list: null,
    }
  },
  mounted() {
    this.getQuizList()
  },
  methods: {
    async getQuizList() {
      const quizService = new QuizService()
      await quizService.getQuizList().then(response => {
        console.log('response === ', response)
        this.list = response;
      })
      .catch(e => {
        console.log('err => ', e);
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.quiz-list-section {
  position: relative;
  top: 132px;
  margin-bottom: 94px;
  padding: 30px 0 80px 0;

  .quiz-list-wrapper {
    margin: 20px 0;
    display: flex;

    .content {
      background-color: #F8F8F8;
      padding: 42px 46px;
      //height: 50vh;
      width: 100%;

      ul {
        padding: 0;
        margin: 0;

        li {
          margin-bottom: 12px;

          a {
            color: #000000;

            &:hover {
              color: #f1bc04;
            }
          }
        }
      }
    }
  }
}
</style>
